import axios from 'axios';

export default {


    getAddressCustomer () {
        return axios.get('/api/customers/address')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {console.log(error);})
    },

    validateCode ( phone , code , password) {
        var registerRequest = {phone:phone , code:code , password:password}
        return axios.post('/api/customers/get/register', registerRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })

    },

    validateCodeForEdition ( phone , code , password) {
        var registerRequest = {phone:phone , code:code , password:password}
        return axios.post('/api/customers/validate/sms-code', registerRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })

    },

    createCode (userName, password, name, phoneNumber , matricule, newsletter, countryId, cityId, address, postalCode , oAuth2code , provider ,oAuth2AccessToken) {
        var registerRequest = {userName:userName, password: password, name: name ,phoneNumber:phoneNumber , 
            companyRegistrationNumber:matricule, newsletter:newsletter, countryId: countryId, cityId:cityId, address:address, postalCode: postalCode , oAuth2code :oAuth2code , provider:provider, oAuth2AccessToken:oAuth2AccessToken}
        return axios.post('/api/customers/get/create-code', registerRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
    }, 

    changeUserInfo (userName, password, name, phoneNumber , matricule) {
        var registerRequest = {userName:userName, password: password, name: name ,phoneNumber:phoneNumber , companyRegistrationNumber:matricule}
        return axios.post('/api/customers/change/user-info', registerRequest)
        .then(response => {
            if (response && response.data) return response.data;
        })
    }, 

    getUserInfo () {
        return axios.get('/api/customers/user-info')
        .then(response => {
            if (response && response.data) return response.data;
        })
    }, 

    sendNewAddress (addressCustomer) {
        return axios.post('/api/customers/send/address', addressCustomer)
        .then(response => {
            if (response && response.data) return response.data;
        })
    }, 
}

